import React, { Component } from "react";
import { connect } from "react-redux";
import Bonuses from "../../../containers/admin/premium/Bonuses";
import { setMenuLeftContent, setMenuLeftIndex, setMenuTopIndex } from "../../../redux/actions/menuActions";
import Menu from "../Menu";
import AuthRender from "../../../containers/AuthRender";
import { SERVICES } from "../../../configs/constants";

class OldBonusContainer extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("presence");
    this.props.setMenuLeftIndex("extrapremium");

    this.props.setMenuLeftContent(Menu);
  }

  render() {
    return (
      <AuthRender service={SERVICES.Primes}>
        <Bonuses {...this.props} />
      </AuthRender>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    }
  };
};
export default connect(null, mapDispatchToProps)(OldBonusContainer);



// WEBPACK FOOTER //
// src/pages/presence/premium/Home.js